module.exports = __webpack_public_path__ + "calltracking-headphones.f826adea0bb3d4102a496ff21fa76942.png";